/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) 2020 Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  profile: 'Profile',
  settings: 'Settings',
  name: 'Name',
  email: 'Email',
  password: 'Password',
  passwordConfirmation: 'Password Confirmation',
  locale: 'Locale',
  view: 'View',
  comfortable: 'Comfortable',
  compact: 'Compact',
  line: 'Line',
  full: 'Full',
  narrow: 'Narrow',
  sort: 'Sort',
  lastModifiedFirst: 'Last Modified First',
  lastCreatedFirst: 'Last Created First',
  alphabetically: 'Alphabetically',
  theme: 'Theme',
  dark: 'Dark',
  light: 'Light',
  save: 'Save',
  saveSuccess: 'Profile saved successfully.',
  saveFailure: 'Profile could not be saved.',
  fetchFailure: 'Profile could not be fetched.',
  application: 'Application',
  install: 'Install',
  youCanInstallPlainpad: 'You can install Plainpad and access it directly from the host machine.',
  invalidateCache: 'Invalidate Cache',
  encrypt: 'Encrypt',
  yes: 'Yes',
  no: 'No',
  passwordsMismatch: 'The provided passwords mismatch, please try again.'
}
